'use client';

import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import SessionExpiredDialog from '@/components/auth/SessionExpiredDialog';
import AuthDialog from '@/components/auth/AuthDialog';

export default function SessionHandler() {
  const { handleSessionExpired } = useAuth();
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const [showAuthDialog, setShowAuthDialog] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expirationTime = payload.exp * 1000;
      const timeUntilExpiry = expirationTime - Date.now();

      if (timeUntilExpiry > 0) {
        const timer = setTimeout(() => {
          handleSessionExpired();
          setShowSessionExpired(true);
        }, timeUntilExpiry);

        return () => clearTimeout(timer);
      }
    }
  }, [handleSessionExpired]);

  const handleLogin = () => {
    setShowSessionExpired(false);
    setShowAuthDialog(true);
  };

  return (
    <>
      <SessionExpiredDialog
        open={showSessionExpired}
        onClose={() => setShowSessionExpired(false)}
        onLogin={handleLogin}
      />
      <AuthDialog
        open={showAuthDialog}
        onClose={() => setShowAuthDialog(false)}
        mode="login"
      />
    </>
  );
}